import { defineActorUser } from '@sigma/actors-core/ActorUser.js';
export const PatientUser = defineActorUser({
    type: 'patient',
    parseId: BigInt,
});
/**
 * Actor user for staff members (doctors and other staff roles).
 *
 * NOTE: The exported symbol is `StaffUser`, but the wire `type` remains `'doctor'`
 * intentionally for transport-auth backward compatibility per the ADR: the actor key
 * prefix (`doctor.<id>`), the authenticator (which maps the doctor Cognito pool to this
 * user), and the doctor-app client all rely on the `'doctor'` type string. Any non-doctor
 * staff in a chat authenticates via the doctor-app path to receive events.
 */
export const StaffUser = defineActorUser({
    type: 'doctor',
    parseId: BigInt,
});
export const GuestUser = defineActorUser({
    type: 'guest',
    parseId: BigInt,
});
//# sourceMappingURL=users.js.map